import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';
import { IListingFilterWidgetSection } from '@components/widgets/listing-filter-widget';
import { FormInputTypes } from '@components/_old/dynamicForm';
import { IAbstractRecord } from '@models';

export const bpAssignedPLansHeaders: Record<string, EnhancedTableHeader> = {
  Line_ExternalCode: {
    name: 'line_ExternalCode',
    title: 'Line Code ',
    type: EnhancedTableHeaderType.Text,
  },
  Line_Name: {
    name: 'line_Name',
    title: 'Line',
    type: EnhancedTableHeaderType.Link,
    urlTemplate:
      '/plan/lines/{salesforceManagement_BusinessPartnerPlan_LineID}',
    openUrlInNewTab: false,
  },
  Line_Status: {
    name: 'line_Status',
    title: 'Line Status',
    type: EnhancedTableHeaderType.Text,
  },

  Plan_ExternalCode: {
    name: 'plan_ExternalCode',
    title: 'Plan Code ',
    type: EnhancedTableHeaderType.Text,
  },
  Plan_Name: {
    name: 'plan_Name',
    title: 'Plan',
    type: EnhancedTableHeaderType.Link,
    urlTemplate:
      '/plan/plans/{salesforceManagement_BusinessPartnerPlan_PlanID}',
    openUrlInNewTab: false,
  },
  Plan_Status: {
    name: 'plan_Status',
    title: 'Plan Status',
    type: EnhancedTableHeaderType.Text,
  },

  SalesforceManagement_BusinessPartnerPlan_PlanCommissionType: {
    name: 'salesforceManagement_BusinessPartnerPlan_PlanCommissionType',
    title: 'Commission Type',
    type: EnhancedTableHeaderType.Text,
  },
  SalesforceManagement_BusinessPartnerPlan_PlanCommissionValue: {
    name: 'salesforceManagement_BusinessPartnerPlan_PlanCommissionValue',
    title: 'Commission',
    type: EnhancedTableHeaderType.Text,
  },
  SalesforceManagement_BusinessPartnerPlan_ApplicableOn: {
    name: 'salesforceManagement_BusinessPartnerPlan_ApplicableOn',
    title: 'Applicable On',
    type: EnhancedTableHeaderType.Text,
  },
  SalesforceManagement_BusinessPartnerPlan_ActiveFrom: {
    name: 'salesforceManagement_BusinessPartnerPlan_ActiveFrom',
    title: 'Active From',
    type: EnhancedTableHeaderType.Date,
  },
  SalesforceManagement_BusinessPartnerPlan_ActiveTo: {
    name: 'salesforceManagement_BusinessPartnerPlan_ActiveTo',
    title: 'Active To',
    type: EnhancedTableHeaderType.Date,
  },
  SalesforceManagement_BusinessPartnerPlan_Status: {
    name: 'salesforceManagement_BusinessPartnerPlan_Status',
    title: '',
    type: EnhancedTableHeaderType.Image,
    hasConditionalImage: true,
    variableOneImageKey:
      'https://ufa-cdn.baibars.club/ufa-app-portal/images/green-correct-img.png',
    variableTwoImageKey:
      'https://ufa-cdn.baibars.club/ufa-app-portal/images/red-clean-img.png',
  },
};

export const filterSectionsContent = (
  lovs: Record<string, Record<string, string>>,
  filterValues: IAbstractRecord
): IListingFilterWidgetSection[] => {
  const newFilterSections: IListingFilterWidgetSection[] = [
    {
      title: '',
      inputs: {
        line: {
          name: 'line',
          title: '',
          type: FormInputTypes.newselect,
          value: filterValues?.line || [],
          placeholder: 'Filter By Line',
          triggerUpdate: true,
          selectOptions: { ...lovs.line },
        },
      },
    },
  ];
  return newFilterSections;
};
